var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, when, makeObservable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
export class QuestionPrepare {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get isQuestionTopicPending() {
        if (!this.question.topic)
            console.log('Waiting for question topic ');
        return !this.question.topic;
    }
    get isPreloadBundleMissing() {
        return this.question.bundles_fallback
            .split(',')
            .filter(bId => !!bId)
            .map(bundleId => {
            const bundle = this.question.model.stream.bundle[bundleId];
            if (!bundle)
                console.log(`Waiting for bundle ${bundleId} for question ${this.question.id}`);
            return bundle;
        })
            .includes(undefined);
    }
    get isAbfragerPackagePending() {
        return this.question.bundlesNames_fallback.includes('Abfrager') && !this.question.context.app.runtime.streamedPackages.Abfrager;
    }
    get isDraftPackagePending() {
        return this.question.bundlesNames_fallback.includes('Draft') && !this.question.context.app.runtime.streamedPackages.Draft;
    }
    get isAnyThingPending() {
        return this.isPreloadBundleMissing || this.isQuestionTopicPending || this.isAbfragerPackagePending || this.isDraftPackagePending;
    }
    get areRequiredResourcesLoaded() {
        return !this.isAnyThingPending;
    }
    async loadRequiredResources() {
        await when(() => !this.isPreloadBundleMissing && !this.isQuestionTopicPending);
        /* 22.09.2020 Bug in Mobx: runtime stuff not notifying when() await */
        if (this.isAbfragerPackagePending)
            await runtime.fetchPackages.Abfrager;
        if (this.isDraftPackagePending)
            await runtime.fetchPackages.Draft;
    }
}
__decorate([
    computed
], QuestionPrepare.prototype, "areRequiredResourcesLoaded", null);
